<template>
    <div class="cookie-banner">
      <div>
    <vue-cookie-accept-decline
    :elementId="'myPanel1'"
    :debug="false"
    :type="'floating'"
    :position="'bottom-right'"
    :disableDecline="true"
    :transitionName="'slideFromBottom'"
    :showPostponeButton="false"
    :forceCookies="false"
    @status="cookieStatus"
    @clicked-accept="cookieClickedAccept"
    @clicked-decline="cookieClickedDecline">

    <!-- Optional -->
    <!-- <div slot="postponeContent">
        &times;
    </div> -->

    <!-- Optional -->
    <div slot="message">
      <div v-if="this.myLang == 'it'">
        <h1>{{this.titleIt}}</h1>
        <p v-html="this.textIt"></p>
      </div>
      <div v-if="this.myLang == 'en'">
        <h1>{{this.titleEn}}</h1>
        <p v-html="this.textEn"></p>
      </div>
    </div>

    <!-- Optional -->
    <!-- <div slot="declineContent">
       OPT OUT
    </div> -->

    <!-- Optional -->
    <div slot="acceptContent">
      <span v-if="this.myLang == 'it'">
            Accetto     
        </span>
        <span v-else>
            Accept
        </span>
    </div>
    </vue-cookie-accept-decline>
    </div>
    </div>
</template>

<script>
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

export default {
  name: 'Header',
  components:{
    VueCookieAcceptDecline
  },
  data:()=>{
    return {
      text:"",
      lang:"",
      myLang:"",
      acceptedCookie:false,
      status: null,
      titleIt:"Cookie policy",
 textIt:`<p>Questo sito non utilizza cookie di profilazione, ma solo cookie tecnici propri e di terzi, anche legati alla presenza dei social plug-in.
  Per saperne di più e disabilitare tutti o alcuni cookie visita la pagina della Cookie Policy. 
  Proseguendo la navigazione senza modificare le impostazioni e cliccando su "ACCETTO" si acconsente all’uso dei cookie.</p>`,
      titleEn:"Cookie policy",
      textEn:`<p>This website does not use profiling cookies, but only first and third party technical cookies, including cookies from social media plugins.
To learn more about our cookie policy or to change your cookie settings visit the Cookie Policy page.
By using this website and clicking “accept”, you consent to the use of cookies in accordance with our cookie policy.</p>`
    }
  },
  props: {
    msg: String,
  },
  methods: {
    cookieStatus (status) {
      console.log('status: ' + status)
      this.status = status
    },
    cookieClickedAccept () {
      console.log('here in accept')
      this.status = 'accept'
    },
    cookieClickedDecline () {
      console.log('here in decline')
      this.status = 'decline'
    },
    cookieRemovedCookie () {
      console.log('here in cookieRemoved')
      this.status = null
      this.$refs.myPanel1.init()
    },
    removeCookie () {
      console.log('Cookie removed')
      this.$refs.myPanel1.removeCookie()
    },
  },
  mounted() {
    this.myLang = this.$route.params.lang
    console.log('ml',this.$route);
  },
}
</script>

<style  lang="scss">
.cookie.cookie__floating.cookie__floating--bottom-right{

  &:before{
    content: "";
    position: absolute;
    background: transparent;
    border: 1px solid #14182e54;
    width: 100%;
    height: 450px;
    top: 0;
    pointer-events: none;
    left: 0;
    transform-origin: center;
    transform: scale(0.95);
  }
    position: fixed;
    z-index: 99;
    border-radius: 0px;
    background: #fff;
    bottom: 0;
    width: 400px;
    right: 50px;
    padding: 0.9rem 1rem 1rem 1rem;
    display: block;
    max-width: none;
    overflow: visible;
    max-height: none;
  h1 {
    font-size: 1.2rem;
    margin-bottom: 0.11rem;
  }
  p{
    font-size: 0.8125rem;
    line-height: 1.4rem;
  }
  a{
    color: #F04533;
  }
  button {
    color: #F04533;
    background: transparent;
    border: 0px;
    font-weight: 600;
    font-size: 0.8125rem;
    float: right;
  }
}
.cookie__floating__content {
  max-height: none;
}
.cookie__floating__content {
    overflow: visible;
}
.cookie__floating__content {
  margin: 0;
}
.cookie__floating__content{
  padding:5px 20px 0px 20px ;
}
.cookie.cookie__floating.cookie__floating--bottom-right button{
  text-align: right;
  padding-right: 50px;
}

@media (max-width:992px){
  .cookie.cookie__floating.cookie__floating--bottom-right{
    width: calc(100% - 30px);
    margin: 0px auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (max-width:768px){
  .cookie.cookie__floating.cookie__floating--bottom-right{
    width: 100% ;
    margin: 0px auto;
    left: 50%;
      padding: 0.9rem 0rem 1rem 0rem;
    transform: translateX(-50%);
  }
  .cookie.cookie__floating.cookie__floating--bottom-right:before {
    display: none;
}
}

</style>
